"use strict";
// SPDX-FileCopyrightText: 2024 Red Bee Media Ltd <https://www.redbeemedia.com/>
//
// SPDX-License-Identifier: MIT
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertError = void 0;
const shaka_player_1 = __importDefault(require("shaka-player"));
const js_player_shared_1 = require("@ericssonbroadcastservices/js-player-shared");
const ErrorMap = {
    NETWORK: js_player_shared_1.ErrorTypes.NETWORK,
    TEXT: js_player_shared_1.ErrorTypes.SEGMENT,
    MEDIA: js_player_shared_1.ErrorTypes.SEGMENT,
    MANIFEST: js_player_shared_1.ErrorTypes.MANIFEST,
    STREAMING: js_player_shared_1.ErrorTypes.MANIFEST,
    DRM: js_player_shared_1.ErrorTypes.DRM,
    PLAYER: js_player_shared_1.ErrorTypes.GENERIC,
    CAST: js_player_shared_1.ErrorTypes.GENERIC,
    STORAGE: js_player_shared_1.ErrorTypes.GENERIC,
};
const nonFatalShakaErrorCodeKeys = [
    "INVALID_TEXT_HEADER",
    "INVALID_TEXT_CUE",
    "UNABLE_TO_DETECT_ENCODING",
    "BAD_ENCODING",
    "INVALID_XML",
    "INVALID_TTML",
    "INVALID_MP4_TTML",
    "INVALID_MP4_VTT",
];
const convertError = (error) => {
    // Set message from error code
    const codeIndex = Object.values(shaka_player_1.default.util.Error.Code).indexOf(error.code);
    const shakaErrorMessage = Object.keys(shaka_player_1.default.util.Error.Code)[codeIndex];
    // Set category from Shaka's defined categories
    const categoryIndex = Object.values(shaka_player_1.default.util.Error.Category).indexOf(error.category);
    const categoryName = Object.keys(shaka_player_1.default.util.Error.Category)[categoryIndex];
    const fatal = error.severity !== shaka_player_1.default.util.Error.Severity.RECOVERABLE &&
        !nonFatalShakaErrorCodeKeys.includes(shakaErrorMessage);
    return {
        error: new js_player_shared_1.ShakaPlayerError(shakaErrorMessage, {
            type: ErrorMap[categoryName] || js_player_shared_1.ErrorTypes.OTHER,
            code: error.code,
        }),
        fatal,
    };
};
exports.convertError = convertError;
//# sourceMappingURL=ShakaErrors.js.map